import { FlowTab as WorkPageTabsEnum } from '@diana/core';

export { FlowTab as WorkPageTabsEnum } from '@diana/core';

export const Tabs = [WorkPageTabsEnum.Workflow, WorkPageTabsEnum.Activities];
